import { extendTheme } from '@chakra-ui/react'
import '@fontsource/montserrat'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'
import '@fontsource/montserrat/800.css'
import '@fontsource/rubik-glitch'
import '@fontsource/sofia-sans'
import '@fontsource/sofia-sans/500.css'
import '@fontsource/sofia-sans/700.css'
import '@fontsource/sofia-sans/800.css'

import { Button } from './components/Button'
import { Tag } from './components/Tag'
import { Progress } from './components/Progress'
import { Checkbox } from './components/Checkbox'
import { Switch } from './components/Switch'
import { Text } from './components/Text'
import { breakpoints } from './foundations/breakpoints'
import { colors } from './cssVariables/colors'

const theme = extendTheme({
  breakpoints,
  colors,
  styles: {
    global: {
      // styles for the `body`
      body: {
        bg: '#111019',
        color: colors.colorB1,
        fontFamily: 'Montserrat',
        fontWeight: 600,
      },
    },
  },
  textStyles: {
    title: {
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 600,
    },
  },
  components: {
    Button,
    Tag,
    Progress,
    Checkbox,
    Switch,
    Text,
  },
})

export default theme
